import { RoadRage } from "../../RoadRage";
import { GameData } from "../../server/data/BaseModel";
import { GameConfig } from "../../config/base/GameConfig";
import { SlotGame } from "@nolimitcity/slot-game/bin/SlotGame";
import { StateHandler } from "../../../dev/utils/StateHandler";
import { IWinRatioConfig } from "../../config/base/IWinConfig";
import { WinGameData } from "../../server/data/GameDataModels";
import { GameMode } from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import { RoadRageSpriteSymbol } from "../../reel/symbol/RoadRageSpriteSymbol";
import { RoadRageEngineManager } from "../../reel/RoadRageEngineManager";
import { Presentation } from "../../../dev/gameflow/controller/Presentation";
import { BigWinPosterState, PosterManager } from "../../independent/poster/PosterManager";
import { SoundManager } from '../../config/sound/SoundManager';
import { SoundConfig } from '../../config/sound/SoundConfig';

class BigWinStates extends StateHandler {
    public static readonly START: string = "start";
    public static readonly SHOW: string = "show";
    public static readonly STOP: string = "stop";
    public static readonly DONE: string = "done";
}

export class NormalBigWinPresentation extends Presentation {

    private _winRatios: IWinRatioConfig[];
    private _winData: WinGameData;

    private _winLevel: number = 0;
    private _currLevel: number = 0;

    private _bounceDuration: number = 0.25;
    private _bigWinStates: BigWinStates = new BigWinStates();

    private isTotalWin: boolean = false;
    private firstBounce: boolean = false;

    private fsLowBigWin: boolean = false;
    private isBelowStake:boolean = false;

    private _countUpValue: number = 0;

    initialization(): void {
        this._winRatios = GameConfig.instance.WIN_RATIOS.bigWin;
    }

    get countUpValue(): number {
        return this._countUpValue;
    }

    set countUpValue(value: number) {
        this._countUpValue = value;
        //SlotGame.keypadPlugin.setWin(value, this.isTotalWin, this.isBelowStake)
    }

    public setGamedData(data: GameData): void {
        this._winData = data.Win;

        this.isBelowStake = data.Win.isWinBelowStake!();

        this.isTotalWin = data.mode !== GameMode.NORMAL && data.Win.totalWin != data.Win.singleWin;
        this._winLevel = this._winRatios.findIndex((indx) => indx.ratio == this._winData.winRatioConfig?.ratio);

        this.fsLowBigWin = data.mode === GameMode.FREESPIN && this._winLevel < 2;
        this._countUpValue = this._winData!.totalWin - this._winData!.singleWin;
    }

    preStart(): void {
        this._currLevel = 0;
        this.firstBounce = true;
        this._bigWinStates.set(BigWinStates.START);
    }

    public checkForActivation(data: GameData): boolean { return data.Win.isBigWin; }

    public createPresentation(enableSkip: Function): void {
        enableSkip(this._bigWinStates.equal(BigWinStates.SHOW));

        switch (this._bigWinStates.value) {
            case BigWinStates.START:
                this.preWin();
                break;
            case BigWinStates.SHOW:
                this.playBigWinLevelAnimation();
                break;
            case BigWinStates.STOP:
                this.postWin();
                break;
            case BigWinStates.DONE:
                this.PresentationState.setInactive();
                break;
            default:
                break;
        }
    }

    private preWin(): void {

        let delay: number = 0;
        let perReel: number = .05;

        let applyDuration: number = 0.75;

        for (let reel = 0; reel < this._winData.allBetWayWinData.reelWinPositions.length; reel++) {
            for (let row = 0; row < this._winData.allBetWayWinData.reelWinPositions[reel].length; row++) {
                const sym: RoadRageSpriteSymbol | undefined = RoadRageEngineManager.getReel(reel).getSymbol(row);
                const hits: boolean = this._winData.allBetWayWinData.reelWinPositions[reel][row];
                if (sym) {
                    this.timeline.add(() => sym.playBigWin(hits, applyDuration), delay);
                }
            }
        }


        SoundManager.fadeOutAmbient(2000,0)
        SoundManager.playSoundEffect(SoundConfig.BIG_WIN_PRE_START)
        
        delay += applyDuration / 2;

        const currentDuration: number = delay + applyDuration;
        
        this.timeline.add(() => {RoadRage.counter.playBigWin(0, this.betValueRatio(0), currentDuration, undefined)}, delay);
        
        this.timeline.to(this, { duration: currentDuration }, 0);
        this.timeline.add(() => {RoadRage.counter.moveDown(false, 0.5)}, "-=" + 0.2);
        this.timeline.add(() => {RoadRage.counter.bounceHit(8, this._bounceDuration); SoundManager.playSoundEffect(SoundConfig.BIG_WIN_LVL_CHANGE)}, "+=" + 0.3);
        this.timeline.add(() => { SoundManager.playBigWin(1,false,false); PosterManager.instance.play(BigWinPosterState.BIG_WIN, { animation: BigWinPosterState.bigWinTypeIntroLvl(0),showOnEnd:true,onComplete:() => {
            PosterManager.instance.play(BigWinPosterState.BIG_WIN, { animation: BigWinPosterState.bigWinTypeLvl(0),loop:true});
        } }, 0.25, 0)}, "-=" + 0.2);

        this.timeline.to(this, { duration: 0.15 });

        this._bigWinStates.set(BigWinStates.SHOW);
    }

    private playAnimLoop(lvl:number){
        SoundManager.playBigWin(lvl+1,false,lvl >= 4)
        PosterManager.instance.play(BigWinPosterState.BIG_WIN, { animation: BigWinPosterState.bigWinTypeIntroLvl(lvl),showOnEnd:true,onComplete:() =>{
            PosterManager.instance.play(BigWinPosterState.BIG_WIN, { animation: BigWinPosterState.bigWinTypeLvl(lvl),loop:true});
        }});
    }

    private postWin(): void {
        
        const stopDurr:number = 0.75;

        this.timeline.add(RoadRage.counter.bounceHit(6, this._bounceDuration), 0)
        RoadRage.particleManager.triggerWinSplash(true);
        SoundManager.stopBigWin();

        SoundManager.playSoundEffect(SoundConfig.BIG_WIN_LVL_CHANGE);
        SoundManager.playSoundEffect(SoundConfig.BIG_WIN_ENDING);
        RoadRage.particleManager.bigWinParticles.enableEmit(false);
        RoadRage.particleManager.bigWinParticles2.enableEmit(false);
        RoadRage.particleManager.bigWinParticles3.enableEmit(false);
        PosterManager.instance.stop(1.5);
        
        this.timeline.add([
            () => {
                SoundManager.fadeInAmbient(4000,1);
            },
            RoadRage.counter.moveToReset(0.8),
        ], this._bounceDuration+0.15);

        this.timeline.add([
            () => { RoadRage.counter.showWays(0.4) },
        ], 1);

        this.timeline.add([ 
            () => { RoadRage.counter.stop(this._winData!.singleWin, 1, 0.25, false) },
        ], 2);
        this.timeline.add(() => SlotGame.keypadPlugin.setWin(this._winData!.totalWin, this.isTotalWin, this.isBelowStake));

        const delay: number = this.timeline.totalDuration();
        // this.timeline.add(() => {RoadRage.counter.moveToReset(1)}, delay)

        for (let reel = 0; reel < this._winData.allBetWayWinData.reelWinPositions.length; reel++) {
            for (let row = 0; row < this._winData.allBetWayWinData.reelWinPositions[reel].length; row++) {
                const sym: RoadRageSpriteSymbol | undefined = RoadRageEngineManager.getReel(reel).getSymbol(row);
                if (sym) {
                    if (this._winData.allBetWayWinData.reelWinPositions[reel][row]) {
                        // this.timeline.add(() => sym.bigWin(false), delay + 0.1);
                    }
                    this.timeline.add(() => sym.stopWin(stopDurr), delay + reel*0.15);
                }
            }
        }

        this.timeline.to(this, { duration: stopDurr });

        const from: number = this._winData!.totalWin - this._winData!.singleWin;
        this.timeline.fromTo(this, { countUpValue: from }, { countUpValue: this._winData!.totalWin, duration: 0.35 }, 0)

        this._bigWinStates.set(BigWinStates.DONE);
    }

    public playBigWinLevelAnimation(): void {

        let bounceDurr: number = 0;
        const presLvl: number = this._currLevel;

        // this.emitt();
        // PosterManager.instance.stop(0.1,true);

        if (this.firstBounce) {
            this.firstBounce = false;
            bounceDurr = 0.25;
        } else {
            bounceDurr = RoadRage.counter.bounceHit(8, this._bounceDuration).duration();
            RoadRage.particleManager.triggerWinSplash(true);
        }

        if (presLvl >= this._winLevel) { // Last lvl Before PostWin

            let countUpDurr: number = this._winRatios[this._winLevel].duration;
            this.timeline.add(this.playBigWinCountUp(this._winLevel, Math.abs(countUpDurr - bounceDurr)), bounceDurr);

            this.activateParticle(presLvl);

            if (presLvl > 0 && presLvl <= 4) {
                this.playAnimLoop(presLvl);
            } else {
                
            }
            this._bigWinStates.set(BigWinStates.STOP);

        } else {

            let countUpDurr: number = GameConfig.instance.WIN_RATIOS.bigWin[presLvl].duration;

            this.timeline.add(this.playBigWinCountUp(presLvl, Math.abs(countUpDurr - bounceDurr)), bounceDurr);
           
            this.activateParticle(presLvl);

            if (presLvl > 0 && this._winLevel !== presLvl && presLvl <= 4) {
                this.playAnimLoop(presLvl);
            } else {

            }
        }

        if (this.overFlowSkip(presLvl, 3)) {
            this._bigWinStates.set(BigWinStates.STOP);
        } else
            this._currLevel++;
    }

    private activateParticle(lvl:number){
        if(lvl === 1){
            RoadRage.particleManager.bigWinParticles.enableEmit(true)
        }else if(lvl === 2){
            RoadRage.particleManager.bigWinParticles2.enableEmit(true)
        }else if(lvl === 4){
            RoadRage.particleManager.bigWinParticles3.enableEmit(true)
        }
    }

    private overFlowSkip(level: number, xRatio: number = 3): boolean {
        let restXVal: number = (this.nextValueRatio(level + 1) - this.betValueRatio(level + 1)) / this._winData!.playedBetValue;
        return restXVal >= 0 && restXVal < (xRatio + (level * xRatio));
    }

    private playBigWinCountUp(level: number, duration: number): gsap.core.Timeline {
        const fromValue: number = this.betValueRatio(level);
        let toValue: number = this.nextValueRatio(level);

        if (this.overFlowSkip(level, 3)) toValue = this.nextValueRatio(level + 1)

        return RoadRage.counter.playBigWin(fromValue, toValue, duration, this._winData.allBetWayWinData.totalWinCombination);
    }

    public done(): void {
        RoadRageEngineManager.RSAll((rc, sym) => sym.markNonWin(false));
    }

    private betValueRatio(level: number): number {
        return this._winData!.playedBetValue * GameConfig.instance.WIN_RATIOS.bigWin[Math.min(level, GameConfig.instance.WIN_RATIOS.bigWin.length - 1)].ratio;
    }

    private nextValueRatio(level: number): number {
        return level + 1 > this._winLevel ? this._winData!.singleWin : this.betValueRatio(level + 1);
    }

}